import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router";
import Footer from "../components/Footer";
import PreFooter from "../components/PreFooter";
import MobileHeader from "./../components/mobile/MobileHeader";
import http from './../services/httpService';
import config from './../services/config.json';
import setFaq from './../redux/FaqSlice'

const MobileLayout = () => {
  const dispatch = useDispatch();

  let iranOut = [];
  let bus = [];
  let insideiran = [];
  let hotel = [];
  let train = [];

  useEffect(() => {
    http
      .get(`${config.FaqApi}/faq.json`)

      .then((res) => Object.entries(res.data))
      .then((data) => {
        data.map((each) => {
          let currentData = Object(each[1]);

          switch (currentData.type) {
            case "insideiran":
              insideiran.push(each[1]);
              break;
            case "iranout":
              iranOut.push(each[1]);
              break;
            case "bus":
              bus.push(each[1]);
              break;
            case "hotel":
              hotel.push(each[1]);
              break;
            case "train":
              train.push(each[1]);
              break;
          }
        });

        dispatch(
          setFaq({
            iranOut,
            insideiran,
            train,
            bus,
            hotel,
          })
        );
      });
  }, []);

  return (
    <>
      <MobileHeader />
      <Outlet />
      <PreFooter />
      <Footer />
    </>
  );
};

export default MobileLayout;
